import { createContext } from "preact"
import type { ComponentChildren } from "preact"
import { useContext, useMemo } from "preact/hooks"
import { resolveHiddenFacetsForCollection } from "@/utils/resolveHiddenFacetsForCollection"

/**
 * Set of facet handles (slugged via `facetHandle()`) that should be hidden
 * for the current page. Resolved once at mount from
 * `data-nosto-hidden-facets` on the Nosto section root.
 *
 * Consumers outside the provider get an empty set — preserves the existing
 * default-visible behavior in tests and non-collection entry points.
 */
const HiddenFacetsContext = createContext<Set<string>>(new Set())

export function useHiddenFacetHandles(): Set<string> {
  return useContext(HiddenFacetsContext)
}

export function HiddenFacetsProvider({ children }: { children: ComponentChildren }) {
  const value = useMemo(() => resolveHiddenFacetsForCollection(), [])
  return <HiddenFacetsContext.Provider value={value}>{children}</HiddenFacetsContext.Provider>
}
